import { apiUrl } from '../config/api';
import axios from 'axios';

const publicHttpClient = axios.create({
  baseURL: apiUrl,
  headers: { Accept: 'Application/Json' },
});

export default publicHttpClient;
